export default {
  'userSetting.label.biggie-card': '大神名片',
};
